import React, { FC } from 'react';

import Skeleton from "@mui/material/Skeleton";
import Grid from "@mui/material/Grid";

const PageFallback: FC = () => {
  return (
    <Grid container sx={{ flex: "1 1" }}>
      {/* No side navigation skeleton on phones, where the nav is at the bottom. */}
      <Grid item sx={{ display: { xs: 'none', sm: 'block' } }}>
        <Skeleton variant="rounded" width={214} height="100%" />
      </Grid>
      <Grid container item sx={{ flex: "1 1", flexDirection: "column" }}>
        <Skeleton variant="text" height={60} sx={{ fontSize: '1rem', margin: "8px 30px" }} />
        <Skeleton variant="rounded" height={124} sx={{ margin: "8px 30px", flex: "1 1" }} />
      </Grid>
    </Grid>
  );
};

export default PageFallback;
